import { makeStyles, TextField } from "@material-ui/core";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Textarea from "../../components/Textarea";
import "../../styles/containers/Order.scss";
import { addOrders, addOrderToBasket } from "../../store/actions/partsActions";
import { Storage } from "aws-amplify";
import Button from "../../components/Button";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../components/Loader";
const useStyles = makeStyles({
  input: {
    height: "20px",
  },
});
function ModalForm({
  previewCanvasRef,
  display,
  handleRetake,
  imageCode,
  imageName,
  handleClose,
}) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const parts = useSelector((state) => state.parts);
  const users = useSelector((state) => state.users);
  const dispatch = useDispatch();
  const { getUser } = users;
  const { addOrder } = parts;
  useEffect(() => {
    dispatch(addOrderToBasket());
  }, [getUser]);
  useEffect(() => {
    dispatch(addOrderToBasket());
    if (addOrder?.success) {
      toast.success(addOrder?.message);
      setLoading(false);
      handleClose();
    } else if (!addOrder?.success && addOrder?.isPost) {
      toast.error(`Order Failed! ${addOrder.error} `);
      setLoading(false);
      handleClose();
    }
  }, [addOrder?.success, addOrder?.isPost]);

  const handleSubmit = (e) => {
    dispatch(addOrderToBasket());
    setLoading(true);
    Storage.put(imageName, imageCode, {
      contentType: "image/jpeg",
    })
      .then((res) => {
        let imageArray = [];
        imageArray.push(res.key);
        let data = {
          image_url: imageArray,
          quantity: e.quantity,
          description: e?.description,
          park_id: getUser?.user?.park_id,
        };
        dispatch(addOrders(data));
      })
      .catch((err) => {
        toast.error(`Error: Cannot add order to Basket! ${err}`);
        setLoading(false);
      });
  };

  const initialValues = {
    quantity: "",
    description: "",
  };
  return (
    <div
      className="ModalForm"
      style={{
        display: `${display}`,
      }}
    >
      <Button
        className="modalButton retake"
        order={true}
        onClick={handleRetake}
        title={"Retake Image"}
      />
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          dirty,
        }) => (
          <Form>
            <div className="canvasDiv">
              <canvas
                ref={previewCanvasRef}
                style={{
                  borderRadius: "5px",
                }}
              />
            </div>
            <input
              type="number"
              className="numberfield"
              name="quantity"
              placeholder="Quantity"
              min="0"
              value={values.quantity}
              onChange={handleChange}
              required
            />
            <Textarea
              placeholder="Description (Optional)"
              name="description"
              className="Textarea"
              value={values.description}
              onChange={handleChange}
            />
            <Button
              disabled={!dirty}
              order={true}
              loader={loading}
              backgroundColor={!dirty ? "#ededed" : null}
              color={!dirty ? "#454545" : null}
              className="modalButton"
              title={"Add to Basket"}
              type="submit"
            ></Button>
          </Form>
        )}
      </Formik>

      <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={2000} />
    </div>
  );
}

export default ModalForm;
